<template>
	<div class="position-relative">
		<div class="search-box">
			<form @submit.prevent="search" class="search-input">
				<input type="text" v-model="searchString" placeholder="Buscar...">
				<div class="icon-close" v-if="searchString !=''" @click="clean" >
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
						<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
					</svg>
				</div>
				<button type="submit">
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
						<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
					</svg>
				</button>


			</form>
			
		</div>
		
	</div>
</template>

<script>
import ecommerceMixins from '@/components/ecommerce/mixins'


export default {
	name: 'SearchBar',
	data() {
		return {
			showSearch:false, 
			searchString: ''
		}
	},
	props:['filters'],
	mixims: [ecommerceMixins],
	beforeMount(){
		if(this.filters.q) this.searchString = this.filters.q
	},
	methods: {
		search() {
			this.filters.q = this.searchString
			this.updateFilters()
		},
		clean(){
			this.filters.q = null
			this.updateFilters()
		}
	},
}
</script>
<style scoped lang="scss">


.search-box{
	.search-input{
		width: 100%;
		margin: auto;
		border: solid 1px #f3f3f3;
		background-color: #ffffff;
		border-radius: 10px;
		display: flex;
		position: relative;
		align-items: center;

		input{
			background-color: transparent !important;
			border: none !important;
			flex-grow: 1;
			font-size: 16px;
			padding: 8px;
		}
		button{
			background-color: #e4e4e4;
			border-radius: 7px;
			width: 32px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: none;
			margin: 4px;
		}

		.icon-close{
			width:16px;
			height:16px;
			background-color: #e9e9e9;
			color: #999999;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 12px;
			cursor: pointer;
			

			&:hover{
				background-color: #d4d4d4;
				color: #848484;
			}
		}
	}
}
</style>
